/* Studio page: the showreel previews muted and plays with sound on request, and blocks rise in as they scroll into view. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Showreel: the MP4 plays muted as a preview while it is on screen;
     the play button restarts it with sound and the player controls */
  var reel = document.querySelector('[data-st-reel]');
  var rv = reel && reel.querySelector('video');
  if (rv) {
    rv.muted = true; rv.setAttribute('muted', ''); rv.playsInline = true;
    var btn = reel.querySelector('.st-play, .mh-st-play');
    if (btn) btn.addEventListener('click', function () {
      reel.classList.add('is-playing');
      rv.muted = false; rv.loop = false; rv.controls = true;
      try { rv.currentTime = 0; } catch (err) {}
      var pr = rv.play(); if (pr && pr.catch) pr.catch(function () {});
    });
    if (!reduce && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (reel.classList.contains('is-playing')) return;
        if (es[0].isIntersecting) { var pr = rv.play(); if (pr && pr.catch) pr.catch(function () {}); } else rv.pause();
      }, { threshold: 0.25 }).observe(reel);
    }
  }

  /* Reveal */
  var items = Array.prototype.slice.call(document.querySelectorAll('.st-reveal, .mh-st-reveal'));
  var groups = new Map();
  items.forEach(function (el) { var p = el.parentElement, n = groups.get(p) || 0; el.style.setProperty('--i', n); groups.set(p, n + 1); });
  if (!('IntersectionObserver' in window) || reduce) {
    items.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }
})();
